export default __webpack_public_path__ + "media/images/coworkr/favicons/icon-9c41ea512d9b59ae125ffbc58943d8aa.ico";